import { render, staticRenderFns } from "./comment-panel.vue?vue&type=template&id=67b856b4&"
import script from "./comment-panel.vue?vue&type=script&lang=js&"
export * from "./comment-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports